import { Outlet } from 'react-router-dom';
import { Layout } from '@components';
import DashboardHeader from '../../components/Header';
import DashboardSider from '../../components/Sider';
import MobileHeader from '@app/Dashboard/components/MobileHeader';
import { responsiveConstant } from '@app/Dashboard/constants';
import styles from './index.module.scss';
import cs from 'classnames';
import MobileMenu from 'src/components/MobileMenu';
import { useStore } from '@store';

const { Content } = Layout;

const DashboardLayout = () => {
  const width = window.innerWidth;
  const { theme } = useStore();
  const layoutClassName = cs([styles['mobile_layout'], styles[theme]]);
  return (
    <Layout style={{ minHeight: '100vh' }}>
      {width > responsiveConstant ? <DashboardSider /> : null}

      <Layout className={width < responsiveConstant ? layoutClassName : ''}>
        {width > responsiveConstant ? <DashboardHeader /> : <MobileHeader />}
        <Content className={styles['outlet_content']}>
          <Outlet />
        </Content>
      </Layout>
      {width < responsiveConstant ? <MobileMenu /> : null}
    </Layout>
  );
};

export default DashboardLayout;
